// extracted by mini-css-extract-plugin
export default {"card-wrapper":"CreateCard_card-wrapper__SSoEp","card-inner-wrapper":"CreateCard_card-inner-wrapper__Cz1tV","card-plus":"CreateCard_card-plus__MrndR"};